import { atom } from "recoil";
export const timeInBusinessState = atom<number>({
  key: "timeInBusinessState",
  default: 0,
});
